import { Cookies } from "react-cookie";
import axios from "axios";
import { setCookiesSync } from "assets/js/common";

const cookies = new Cookies();

const favInfo = cookies.get("favInfo");

let cookieExpires = new Date();
cookieExpires.setDate(cookieExpires.getDate() + 180);

export const setFavInfo = (data) => {
  setCookiesSync("favInfo", data);
  // cookies.set("favInfo", data, {
  //   path: "/",
  //   expires: cookieExpires,
  // });
}; // favInfo update

export const refreshFavInfo = () => {
  axios.get("/api/mb/member/my-info").then((res) => {
    let member = res.data.data.member;
    let localFavInfo = cookies.get("favInfo");
    setCookiesSync('favInfo',{
      defaultTp: member.mainTp,
      visibleTp:
        localFavInfo && localFavInfo.visibleTp ? localFavInfo.visibleTp : 1,
      favMk: member.favMk,
      favMt: member.favMt,
    })
    // cookies.set(
    //   "favInfo",
    //   {
    //     defaultTp: member.mainTp,
    //     visibleTp:
    //       localFavInfo && localFavInfo.visibleTp ? localFavInfo.visibleTp : 1,
    //     favMk: member.favMk,
    //     favMt: member.favMt,
    //   },
    //   {
    //     path: "/",
    //     expires: cookieExpires,
    //   }
    // );

    let tag = res.data.data.tag;
    if (window.Android) {
      window.Android.setPushTag(tag);
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "setPushTag",
        tag: tag,
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    }
  });
}; // favInfo refresh
